import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from 'vue-router/composables';

import { Modal, HelperViewContextual } from '@warrenbrasil/nebraska-web';
import { StorageKeys } from '@/modules/common/services/local-storage';

interface Props {
  isOpen: boolean;
}
interface Emits {
  (e: 'close'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'WatchlistModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {





const handleClose = () => {
  setWatchlistModalHasOpened();
  emit('close');
};

const router = useRouter();

const setWatchlistModalHasOpened = () => {
  localStorage.setItem(StorageKeys.HasOpenedWatchlistModal, 'true');
};

const goToSearchPage = () => {
  setWatchlistModalHasOpened();
  router.push({ name: 'tradeSearch' });
};

return { __sfc: true,emit, handleClose, router, setWatchlistModalHasOpened, goToSearchPage, Modal, HelperViewContextual }
}

})